import {
	Menu,
	TableCell,
	TableRow,
	MenuItem,
	IconButton,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { useMenu } from 'hooks';
import { formatDisplayDate } from 'lib/utils';
import React from 'react';

const PromoRuleItem = ({
	promo,
	handleClick,
	handleEditClick,
	handleDeleteClick
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(promo, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(promo, e)}>Delete</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(promo)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Typography variant="primary.text">{promo.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{promo.duration}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{formatDisplayDate(promo.created_at)}
				</Typography>
			</TableCell>

			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default PromoRuleItem;
